import { AlertMessage, MUIIcon, Spinner } from "../../../../widgets"
import { FC, useEffect, useState } from "react"

import { IPaymentButtonProps } from "../IPaymentButtonProps"
import { PageLinkHelper } from "../../../../base/helpers"
import clsx from "clsx"
import { getButtonClass } from "../../buttons/helper"
import { submitForm } from "../../../helpers/submit-form"
import { toAbsoluteUrl } from "../../../../../helpers"
import { useAuth } from "../../../../../modules/auth"
import { useGetBankListHashMutation, useGetFPXHashMutation } from "./services"
import { ButtonStyle, ControlSize } from "../../../../base/types"

export const FPXBankButton: FC<IPaymentButtonProps> = ({
    orderNo, enrolmentNo, entity, entityId, amount,
    firstName, lastName, email, phoneNumber,
    successPage, failedPage, disabled, tooltip,
    style, size, icon, className, label, children
}) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [error, setError] = useState<string>()
    const [selectedBank, setSelectedBank] = useState<string>("");

    const { siteId } = useAuth()
    const [getHash] = useGetFPXHashMutation()

    const handleOnClick = () => {
        if (amount < 1) {
            setError("Transaction Amount is Lower than the Minimum Limit RM1.00 for B2C")
            return;
        } if (amount > 30000) {
            setError("Transaction Amount is greater than the Maximum Limit RM30000.00 for B2C")
            return;
        };

        if (!siteId || !orderNo || !amount || !successPage || !failedPage) return;
        setIsSubmitting(true)
        setError('')

        const successPageUrl = PageLinkHelper.getPageLinkUrl(siteId, successPage);
        const failedPageUrl = PageLinkHelper.getPageLinkUrl(siteId, failedPage);

        getHash({
            orderNo,
            enrolmentNo,
            entity,
            entityId,
            amount,
            firstName,
            lastName,
            email,
            phoneNumber,
            successPageUrl,
            selectedBank,
            failedPageUrl
        })
            .unwrap()
            .then(data => {
                submitForm(data.url, data.formData, "post")
            })
            .catch((err) => {
                setError('Failed to generate payment request.');
                console.log("Error", err);
                setIsSubmitting(false)
            })
            .finally()
    }

    return (
        <>
            {/* <button
                disabled={disabled === true || isSubmitting === true || !orderNo || !amount}
                type="button"
                title={tooltip}
                onClick={handleOnClick}
                className={clsx(getButtonClass(style, size, "btn-secondary"), className)}
            >
                <Spinner show={isSubmitting} className="me-1" />
                <img
                    alt='img'
                    className='h-25px'
                    src={toAbsoluteUrl('/media/logos/FPX_Logo_FA_Full_FC.png')}
                />

                {(!isSubmitting && icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                {label && <span>{label}</span>}
                {children}
            </button> */}

            <FPXPaymentPage isSubmitting={isSubmitting} amount={amount} enrolmentNo={enrolmentNo} onBankChange={setSelectedBank} handleOnClick={handleOnClick} children={children} className={className} disabled={disabled} icon={icon} label={label} orderNo={orderNo} size={size} style={style} tooltip={tooltip} error={error} />
        </>
    )
}

const FPXPaymentPage = ({
    amount,
    enrolmentNo,
    onBankChange,
    handleOnClick,
    disabled, tooltip, error,
    style, size, icon, className, label, children, orderNo, isSubmitting
}: {
    amount: number;
    enrolmentNo: string;
    onBankChange: (bank: string) => void;
    handleOnClick: any,
    error?: string,
    disabled?: boolean,
    isSubmitting?: boolean,
    icon?: string,
    label?: string,
    tooltip?: string,
    style?: ButtonStyle,
    size?: ControlSize,
    className?: string,
    children?: React.ReactNode
    orderNo?: string
}) => {
    const [selectedBank, setSelectedBank] = useState("");
    const [loading, setLoading] = useState<boolean>(false);
    const [error1, setError] = useState<string>();
    const [bankList, setBankList] = useState<any[]>([]);

    const [getHash, { data }] = useGetBankListHashMutation();

    // 🔹 Full Bank Master List
    const masterBankList = [
        { id: "ABB0233", name: "Affin Bank Berhad", display: "Affin Bank" },
        { id: "ABMB0212", name: "Alliance Bank Malaysia Berhad", display: "Alliance Bank (Personal)" },
        { id: "AGRO01", name: "BANK PERTANIAN MALAYSIA BERHAD (AGROBANK)", display: "AGRONet" },
        { id: "AMBB0209", name: "AmBank Malaysia Berhad", display: "AmBank" },
        { id: "BCBB0235", name: "CIMB Bank Berhad", display: "CIMB Clicks" },
        { id: "BIMB0340", name: "Bank Islam Malaysia Berhad", display: "Bank Islam" },
        { id: "BKRM0602", name: "Bank Kerjasama Rakyat Malaysia Berhad", display: "Bank Rakyat" },
        { id: "BMMB0341", name: "Bank Muamalat Malaysia Berhad", display: "Bank Muamalat" },
        { id: "BOCM01", name: "Bank Of China (M) Berhad", display: "Bank Of China" },
        { id: "BSN0601", name: "Bank Simpanan Nasional", display: "BSN" },
        { id: "HLB0224", name: "Hong Leong Bank Berhad", display: "Hong Leong Bank" },
        { id: "HSBC0223", name: "HSBC Bank Malaysia Berhad", display: "HSBC Bank" },
        { id: "KFH0346", name: "Kuwait Finance House (Malaysia) Berhad", display: "KFH" },
        { id: "MB2U0227", name: "Malayan Banking Berhad (M2U)", display: "Maybank2U" },
        { id: "MBB0228", name: "Malayan Banking Berhad (M2E)", display: "Maybank2E" },
        { id: "MBSB001", name: "MBSB Bank Berhad", display: "MBSB Bank" },
        { id: "OCBC0229", name: "OCBC Bank Malaysia Berhad", display: "OCBC Bank" },
        { id: "PBB0233", name: "Public Bank Berhad", display: "Public Bank" },
        { id: "RHB0218", name: "RHB Bank Berhad", display: "RHB Bank" },
        { id: "SCB0216", name: "Standard Chartered Bank", display: "Standard Chartered" },
        { id: "UOB0226", name: "United Overseas Bank", display: "UOB Bank" },
    ];

    // 🔹 Parse FPX response (e.g., ABB0233~A,...)
    useEffect(() => {
        handleGetBankList();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (data?.bankList) {
            const availableBanks: Record<string, string> = {};
            data.bankList.split(",").forEach((item: string) => {
                const [code, status] = item.split("~");
                availableBanks[code.trim()] = status.trim();
            });

            // merge with master list
            const merged = masterBankList.map((bank) => ({
                ...bank,
                status: availableBanks[bank.id] || "N", // mark offline if not found
            }));

            setBankList(merged);
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [data]);

    const handleGetBankList = () => {
        setLoading(true);
        setError("");
        getHash()
            .unwrap()
            .catch((err) => {
                setError("Failed to generate payment request.");
                console.log("Error", err);
                setLoading(false);
            });
    };

    return (
        <div className="container mt-5" style={{ maxWidth: "700px" }}>
            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <h5 className="card-title text-primary mb-3">
                        Pay with{" "}
                        <span>
                            <img
                                alt="img"
                                className="h-25px"
                                src={toAbsoluteUrl("/media/logos/FPX_Logo_FA_Full_FC.png")}
                            />
                        </span>{" "}
                    </h5>

                    <div className="bg-light p-3 rounded mb-4">
                        <p className="mb-1">
                            <strong>Total:</strong>{" "}
                            <span className="text-dark">{amount}</span>
                        </p>
                        <p className="mb-0">
                            <strong>Reference No:</strong>{" "}
                            <span className="text-dark">{enrolmentNo}</span>
                        </p>
                    </div>

                    {error1 && <div className="alert alert-danger">{error1}</div>}

                    <div className="mb-4">
                        <label htmlFor="bankSelect" className="form-label fw-bold">
                            Select Bank:
                        </label>

                        <select
                            id="bankSelect"
                            className="form-select"
                            value={selectedBank}
                            onChange={(e) => {
                                onBankChange(e.target.value)
                                setSelectedBank(e.target.value)
                            }}
                            required
                        >
                            <option value="">Select Bank</option>
                            <optgroup label="Retail Banking:">
                                {loading ? (
                                    <option disabled>Loading banks...</option>
                                ) : (
                                    bankList.map((bank) => {
                                        const isOffline = bank.status !== "A";
                                        const isDisabled = isOffline && bank.id !== selectedBank;

                                        return (
                                            <option
                                                key={bank.id}
                                                value={bank.id}
                                                disabled={isDisabled}
                                                style={{
                                                    color: isOffline ? "#817f7f" : "#000",
                                                    backgroundColor: isOffline ? "#f5f5f5" : "#fff"
                                                }}
                                            >
                                                {bank.display} {isOffline ? "(Offline)" : ""}
                                            </option>
                                        );
                                    })
                                )}
                            </optgroup>
                        </select>

                    </div>

                    <p className="small text-muted">
                        By clicking on the “Proceed” button, you hereby agree with FPX’s{" "}
                        <a href="https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp" target="_blank" className="text-decoration-none" rel="noreferrer">
                            Terms & Conditions
                        </a>.
                    </p>

                    <button
                        disabled={disabled === true || isSubmitting === true || !orderNo || !amount}
                        type="button"
                        title={tooltip}
                        onClick={handleOnClick}
                        className={clsx(getButtonClass(style, size, "btn-secondary"), className)}
                    >
                        <Spinner show={isSubmitting} className="me-1" />
                        Proceed With{" "}
                        <img
                            alt='img'
                            className='h-25px'
                            src={toAbsoluteUrl('/media/logos/FPX_Logo_FA_Full_FC.png')}
                        />

                        {(!isSubmitting && icon) && <MUIIcon iconName={icon} className={clsx({ "me-1": !!label })} />}
                        {label && <span>{label}</span>}
                        {children}
                    </button>

                    <div className="text-end mt-4">
                        <small className="text-muted">
                            Powered by{" "}
                            <span>
                                <img
                                    alt="img"
                                    className="h-25px"
                                    src={toAbsoluteUrl("/media/logos/FPX_Logo_FA_Full_FC.png")}
                                />
                            </span>
                        </small>
                    </div>
                    <AlertMessage type="Error" show={!!error} message={error} />
                </div>
            </div>
        </div>
    );
};

export default FPXPaymentPage;
